export const SIGN_IN_PATH = '/sign-in';
export const SIGN_UP_PATH = '/sign-up';
export const FORGOT_PASSWORD_PATH = '/forgot-password';
export const RESET_PASSWORD_PATH = '/reset-password';
export const PROFILE_PATH = '/profile';
export const HOME_PATH = '/';
export const SUPPORT_PATH = '/support';
export const STAMP_CARD_PATH = '/stamp-cards';
export const BOOKING_PATH = '/booking';
export const BOOK_PATH = '/book';
export const THANK_YOU_PATH = '/thank-you';
export const BOOKING_AREAS_PATH = 'areas';
export const BOOKING_LOCATION_PATH = 'locations';
export const BOOKING_SLOTS_PATH = 'slots';
export const BOOKING_DETAILS_PATH = 'details';
export const BOOKING_REVIEW_PATH = 'review';
export const BOOKING_UPCOMING_PATH = BOOKING_PATH + '/:id';
export const AREAS_PATH = 'areas';
export const AREA_PATH = AREAS_PATH + '/:id';
export const LOCATIONS_PATH = 'locations';
export const LOCATION_PATH = LOCATIONS_PATH + '/:id';
export const HOME_ADMIN_PATH = '/';
export const AREAS_ADMIN_PATH = '/areas';
export const AREA_ADMIN_PATH = AREAS_ADMIN_PATH + '/:id';
export const AREA_LOCATION_ADMIN_PATH = AREA_ADMIN_PATH + '/:locationId';
export const USERS_ADMIN_PATH = '/users';
export const USERS_DETAILS_ADMIN_PATH = USERS_ADMIN_PATH + '/:id';
export const LOCATIONS_ADMIN_PATH = '/locations';
export const LOCATION_ADMIN_PATH = LOCATIONS_ADMIN_PATH + '/:id';
export const LOCKERS_ADMIN_PATH = '/lockers';
export const LOCKER_ADMIN_PATH = LOCKERS_ADMIN_PATH + '/:id';
export const STATIONS_ADMIN_PATH = '/stations';
export const STATION_DETAIL_ADMIN_PATH = STATIONS_ADMIN_PATH + '/:id';
export const BOOKINGS_ADMIN_PATH = '/bookings';
export const BOOKING_ADMIN_PATH = BOOKINGS_ADMIN_PATH + '/:id';
export const ACTIVE_BOARDS_ADMIN_PATH = '/active-boards';
export const DISCOUNTS_ADMIN_PATH = '/discounts';
export const LOCKER_REPORTS_ADMIN_PATH = '/locker-reports';

export const BOOKING_HISTORY_PATH = '/booking-history';

export const getBookPath = (path: string) => `${BOOK_PATH}/${path}`;
export const getBookingDetailsPath = (path: string) =>
  `${BOOKING_PATH}/${path}`;
